export async function releaseShipmentsInProcessUseCase(shipmentInProcessRepository, trace_id) {
    const result = await shipmentInProcessRepository.shipments_release(trace_id);

    return result;    
}